export default "__VITE_ASSET__Bqr2t4sz__"